import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import Loader from '../components/Loader';

class SellerRating extends Component {

    constructor(props) {
        super(props);
        const { location } = props;
        let rating
        let loading = false;

        this.state = {
            rating,
            loading
        };
    }

    componentWillMount(){
    }

    componentDidMount() {        
        this.getSellerRating()
    }

    getSellerRating = () => {

        const { params: { vendor } } = this.props;

        this.setState({ loading: true });

        return api(`/api/giftr/rating/${vendor}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(result => {

            this.setState({ loading: false });

            if(result){
                this.setState({ 
                    rating: result });        
            } else {
                this.setState({ 
                    invalidPostcode: true,
                    result: undefined
                 });        
            }
        })
    }


    render() {
        const { error } = this.props
        const { rating, loading } = this.state;
    
        return (
            <div>
                {
                    !loading && rating &&
                    <div>Seller Ratings: {rating}</div>
                }
            </div>
        );
    }
}

export default connect((state, props) => {

    return {
        
    };
})(SellerRating);